import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  FormControl,
  Flex,
  Input,
} from '@chakra-ui/react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'

export function ModalFiltroInicial({ submitForm, isSubmitting }) {
  const [isOpen, setIsOpen] = useState(true)
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm()

  function onClose() {
    setIsOpen(false)
  }

  async function handleFilter(data) {
    const params = {
      pendente: 'S',
      ...data,
    }

    await submitForm(params)

    onClose()
  }

  return (
    <>
      <Drawer isOpen={isOpen} placement="top" size="lg" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Filtro Inicial</DrawerHeader>

          <DrawerBody display="flex" alignItems="center" justifyContent="center" flexDirection="column" w="full" px="6rem">
            <FormControl py=".5rem" as="form" onSubmit={handleSubmit(handleFilter)}>
              <Flex flexDir="column" align="center" w="full" px="6rem" justifyContent="space-between" flexWrap="wrap">
                <Flex align="start" justify="space-between" gap="1rem" w="full">
                  <Flex gap="4rem" w="full" alignItems="center" justifyContent="center">
                    <Flex maxW="300px" w="full" alignItems="start" flexDir="column">
                      <Input
                        autoFocus
                        maxW="400px"
                        w="full"
                        placeholder="Número do pedido"
                        {...register('numero_pedido')}
                        borderColor={errors.numero_pedido ? 'red.500' : '#378BBF'}
                        variant="flushed"
                        size="sm"
                      />
                      {!!errors.numero_pedido && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.numero_pedido.message}</span>}
                    </Flex>
                    <Flex maxW="400px" w="full" alignItems="start" flexDir="column">
                      <Input
                        autoFocus
                        maxW="300px"
                        w="full"
                        placeholder="Número do pedido de compra"
                        {...register('pedido_compra')}
                        borderColor={errors.pedido_compra ? 'red.500' : '#378BBF'}
                        variant="flushed"
                        size="sm"
                      />
                      {!!errors.pedido_compra && <span style={{ color: 'red', fontSize: '.9rem' }}>{errors.pedido_compra.message}</span>}
                    </Flex>
                  </Flex>
                </Flex>

                <Flex gap={2}>
                  <Button
                    colorScheme="blue"
                    variant="outline"
                    mt="1rem"
                    type="submit"
                    px="2rem"
                    bg="#378BBF"
                    color="white"
                    _hover={{ bg: '#378BBF' }}
                    isLoading={isSubmitting}
                    size="sm"
                  >
                    Filtrar
                  </Button>
                  <Button
                    onClick={() => {
                      handleFilter({})
                    }}
                    colorScheme="blue"
                    variant="outline"
                    mt="1rem"
                    px="2rem"
                    isLoading={isSubmitting}
                    size="sm"
                  >
                    Mostrar Tudo
                  </Button>
                </Flex>
              </Flex>
            </FormControl>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}
